"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireDefault(require("react"));

var _p;

var CommonErrorBoundary = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(CommonErrorBoundary, _React$Component);

  CommonErrorBoundary.resourceType = function resourceType() {
    return 'CommonErrorBoundary_1_0_0';
  };

  function CommonErrorBoundary(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      hasError: false
    };
    return _this;
  }

  var _proto = CommonErrorBoundary.prototype;

  _proto.componentDidCatch = function componentDidCatch(error) {
    console.error(error); // Display fallback UI

    var errorMsg = this.props.errorMsg || 'An error has been caught';
    this.setState({
      hasError: true
    });
    throw new Error(errorMsg);
  };

  _proto.render = function render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return '';
    }

    return this.props.children || _p || (_p = /*#__PURE__*/_react["default"].createElement("p", null, "No children here"));
  };

  return CommonErrorBoundary;
}(_react["default"].Component);

exports["default"] = CommonErrorBoundary;
CommonErrorBoundary.displayName = 'CommonErrorBoundary';